/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUsageBasedInvoices200ResponseFailuresInner
 */
export interface CreateUsageBasedInvoices200ResponseFailuresInner {
    /**
     * 
     */
    spName?: string;
    /**
     * 
     */
    clientName?: string;
    /**
     * 
     */
    error?: string;
}

/**
 * Check if a given object implements the CreateUsageBasedInvoices200ResponseFailuresInner interface.
 */
export function instanceOfCreateUsageBasedInvoices200ResponseFailuresInner(value: object): value is CreateUsageBasedInvoices200ResponseFailuresInner {
    return true;
}

export function CreateUsageBasedInvoices200ResponseFailuresInnerFromJSON(json: any): CreateUsageBasedInvoices200ResponseFailuresInner {
    return CreateUsageBasedInvoices200ResponseFailuresInnerFromJSONTyped(json, false);
}

export function CreateUsageBasedInvoices200ResponseFailuresInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUsageBasedInvoices200ResponseFailuresInner {
    if (json == null) {
        return json;
    }
    return {
        
        'spName': json['spName'] == null ? undefined : json['spName'],
        'clientName': json['clientName'] == null ? undefined : json['clientName'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function CreateUsageBasedInvoices200ResponseFailuresInnerToJSON(json: any): CreateUsageBasedInvoices200ResponseFailuresInner {
    return CreateUsageBasedInvoices200ResponseFailuresInnerToJSONTyped(json, false);
}

export function CreateUsageBasedInvoices200ResponseFailuresInnerToJSONTyped(value?: CreateUsageBasedInvoices200ResponseFailuresInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spName': value['spName'],
        'clientName': value['clientName'],
        'error': value['error'],
    };
}

